module.exports = __webpack_public_path__ + "static/img/super-chat-pass-off.69b17420.png";